import React from "react";
import { Link } from "react-router-dom";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { Icon } from "@/components/kit";
import { useI18n } from "@/i18n";

export function PublicHeader() {
  const { t } = useI18n();
  return (
    <header className="sticky top-0 z-40 border-b border-line bg-paper/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3">
        <Link to="/" className="flex items-center gap-2" data-testid="header-logo">
          <img src="/logo.png" alt="Déco Ligot" className="h-9 object-contain" />
        </Link>
        <nav className="flex items-center gap-2 sm:gap-4">
          <Link
            to="/quotes"
            data-testid="nav-quotes"
            className="hidden items-center gap-1.5 text-[14px] font-medium text-ink-3 transition-colors hover:text-brand sm:flex"
          >
            <Icon name="file-text" size={16} /> {t("tab_quotes")}
          </Link>
          <Link
            to="/admin"
            data-testid="nav-admin"
            className="flex items-center gap-1.5 rounded-full bg-paper-3 px-3.5 py-1.5 text-[14px] font-medium text-ink-2 transition-colors hover:bg-brand-tertiary"
          >
            <Icon name="lock" size={15} /> <span className="hidden sm:inline">{t("tab_pro")}</span>
          </Link>
          <LanguageSwitcher />
        </nav>
      </div>
    </header>
  );
}
